/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Delete_Loading_TitleInputs */

const es_user_profile_api_keys_toasts_delete_loading_title = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando clave API`)
};

const en_user_profile_api_keys_toasts_delete_loading_title = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing API key`)
};

/**
* | output |
* | --- |
* | "Removing API key" |
*
* @param {User_Profile_Api_Keys_Toasts_Delete_Loading_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_delete_loading_title = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Delete_Loading_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Delete_Loading_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_delete_loading_title(inputs)
	return en_user_profile_api_keys_toasts_delete_loading_title(inputs)
});
export { user_profile_api_keys_toasts_delete_loading_title as "user.profile.api_keys.toasts.delete.loading_title" }